import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "@/App";
import "@/i18n/config";
import { installConsoleCapture } from "@/lib/consoleCapture";
import { registerServiceWorker } from "@/pwa/register";
import "@/styles/globals.css";

// Capture recent errors in memory so a manual bug report can include them.
installConsoleCapture();

// Register the PWA service worker in production builds (the built /sw.js does not
// exist under the dev server).
if (import.meta.env.PROD) registerServiceWorker();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root not found");
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
